<template>
    <v-dialog
    v-model="dialog"                
    width="80%"    
    >        
        <v-card>
            <v-card-title
            class="grey lighten-2 title"
            primary-title
            >
            <div>
                {{this.dialogData.titulo}}    <br>                 
            </div>                                             
            </v-card-title>                            
            <v-card-text>
                {{this.dialogData.contenido}}
            </v-card-text> 
                                 
            <v-card-actions>
            <v-spacer></v-spacer>
            
            
            <v-btn
                color="green"
                flat
                @click="edit()"
            >
                Editar
            </v-btn>
            <v-btn
                color="primary"
                flat
                @click="noOrder()"
            >
                Visita sin pedido
            </v-btn>
            <v-btn                
                color="primary"
                flat                
                @click="setOrder()"
            >
                Pedido
            </v-btn>
            
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
import commentList from '@/components/commentList.vue'
export default {
    name: 'calEventlDialog',
    data () {
      return {             
      }
    },
    components: {
        commentList
    },
    methods:{                        
        noOrder(){
            //console.log(this.dialogData);
            /*this.visitaSinPedido(this.dialogData.event.no);
            this.dialog = false;*/
            //this.sinPedido = true;
            this.$store.state.visitaSinPedido = true;
             this.$store.state.visitaComentarios = false;
            this.getTodoComments(this.dialogData.event.no);
            this.dialog = false;
            this.$router.push('sinpedido');
        },
        setOrder(){
            this.$store.state.visitaSinPedido = false;
            this.$store.state.visitaComentarios = false;
            this.$store.state.custFilter = this.dialogData.event.customer;
            this.$store.state.idEvento = this.dialogData.event.no;        
            this.getCustomers(true);         
            this.$store.commit('setSelectedCust',0);           
            this.getTodoComments(this.dialogData.event.no);
            this.dialog = false;
        },
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        }, 
        edit(){
            console.log(this.dialogData.event);
            this.$store.state.visitaSinPedido = false;
            this.$store.state.visitaComentarios = false;
            this.getTodoComments(this.dialogData.event.no);
            this.$store.state.dialogCreateTodoData.editEvent = true;
            
            if (this.dialogData.event.customer != ''){
                this.$store.commit('setCustFilter',this.dialogData.event.customer);
                this.$store.commit('setClientePotencial',false);
                this.$store.commit('setNombreCP','');
                this.getCustomers();
                this.$store.commit('setSelectedCust',0);
            }
            if (this.dialogData.event.potentialCustomer){
                this.$store.commit('setClientePotencial',true);
                this.$store.commit('setNombreCP',this.dialogData.event.potentialCustomerName);
            }
            this.$store.commit('setHourStart',this.dialogData.event.startTime_);
            this.$store.commit('setHourEnd',this.dialogData.event.endTime_);
            this.$store.commit('setNotaVisita',this.dialogData.event.note);
            /*
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            */
            var d = (new Date(Date.parse(this.dialogData.event.date) - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.$store.commit('setVisitaDate',d);
            this.$store.commit('setVisitaDateFormatted',this.formatDate(d));
            this.$store.state.dialogCreateTodoData.notaVisita = this.dialogData.event.note;
            this.dialog = false;
            this.$router.push('editarvisita');
        }
    },
    watch:{
        dialog: function(val, oldVal){
            if (val) this.sinPedido = false;
        }
    },
    computed: {     
        dialog:{
            get(){
                return this.$store.state.calEventDialog;
            },
            set(value){
                //this.$store.commit('setCalEventDialog', value)
                this.$store.state.calEventDialog = value;
            }
        }, 
        dialogData: {
            get(){
                return this.$store.state.calEventDialogData;
            }
        },
        comentario: {
            get(){
                return this.$store.state.dialogCreateTodoData.comentario;
            },
            set(value){
                this.$store.commit('setComentarioVisita',value);
            }
        },
    } 
}
</script>

